import i18n from '../i18n';
import type { SportContext } from './sportContext';
import {
  getSportContext,
  fetchSportContext,
  fallbackSportContext,
  refreshFallbackSportContext
} from './sportContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const tt = (key: string, opts?: Record<string, unknown>) => (i18n as any).t(key, opts);
const t = (key: string, opts?: Record<string, unknown>) => tt(`onboarding:${key}`, opts);

export function getOwnerTour(ctx: SportContext) {
  const c = ctx.copy;
  return [
    {
      target: '[data-onboarding="dashboard-main"]',
      title: t('tourTitleMainScreen'),
      content: c.tourDashboard,
      placement: 'bottom',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-schedule"]',
      title: tt('nav:schedule'),
      content: c.tourSchedule,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-students"]',
      title: c.tourStudentsTitle,
      content: c.tourStudents,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-applications"]',
      title: tt('nav:applications'),
      content: c.tourApplications,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-staff"]',
      title: tt('nav:staff'),
      content: c.tourStaff,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-settings"]',
      title: tt('settings:title'),
      content: t('tourSettingsContent'),
      placement: 'right',
      skipBeacon: true
    }
  ];
}

export function getOwnerChecklist(ctx: SportContext) {
  return [
    {
      key: 'create_venue',
      label: t('checklistCreateVenue'),
      description: t('ownerChecklistVenueDesc', { example: ctx.venueExample }),
      route: '/schedule'
    },
    {
      key: 'create_staff',
      label: t('checklistCreateStaff'),
      description: t('ownerChecklistStaffDesc'),
      route: '/staff'
    },
    {
      key: 'create_group',
      label: t('checklistCreateGroup'),
      description: t('ownerChecklistGroupDesc', { example: ctx.groupExample }),
      route: '/school'
    },
    {
      key: 'add_student',
      label: t('checklistAddStudent'),
      description: t('ownerChecklistStudentDesc', { example: ctx.studentExample }),
      route: '/students'
    },
    {
      key: 'assign_student',
      label: t('checklistAssignStudent'),
      description: t('ownerChecklistAssignDesc'),
      route: '/students'
    },
    {
      key: 'create_schedule',
      label: t('checklistCreateSchedule'),
      description: t('ownerChecklistScheduleDesc', { example: ctx.scheduleExample }),
      route: '/schedule'
    },
    {
      key: 'create_plan',
      label: t('ownerChecklistCreatePlan'),
      description: t('ownerChecklistPlanDesc', { example: ctx.planExample }),
      route: '/school'
    },
    {
      key: 'setup_payment',
      label: t('ownerChecklistSetupPaymentLabel'),
      description: t('checklistSetupPayment'),
      route: '/school/settings'
    }
  ];
}

export {
  getSportContext,
  fetchSportContext,
  fallbackSportContext,
  refreshFallbackSportContext
};
